import { ActionContext, ActionTree, GetterTree, MutationTree } from 'vuex'
import { SET_USER, CLEAR_USER, SET_USER_SERVICES } from '@/store/user/mutations'
import { Service, User } from '@/store/user/types'
import { UserState } from "@/store/user/state"
import { parseAxiosError } from '@/services/api'
import { getUserInfo, logout, sendStat, settingsSave } from '@/store/user/api-requests'
import { RootState } from '../state'
import { SettingsSavePost } from './api-types'

type UserContext = ActionContext<UserState, RootState>

const getDefaultState = () => {
  return {
    user: {
      name: 'unknown',
      email: 'unknown',
      services: []
    },
    lastUpdate: null
  }
}

const initialState: UserState = getDefaultState()

const getters: GetterTree<UserState, RootState> = {
  user(state: UserState): UserState {
    return state
  },
  userServices(state: UserState): Service[] | undefined {
    return state.user?.services
  },
  lastUpdate(state: UserState): Date | null {
    return state.lastUpdate
  }
}

const mutations: MutationTree<UserState> = {
  [SET_USER](state: UserState, user: User) {
    state.user = user
    state.lastUpdate = new Date(new Date().setHours(new Date().getHours() + 1))
  },
  [CLEAR_USER](state: UserState) {
    Object.assign(state, getDefaultState())
  },
  [SET_USER_SERVICES](state: UserState, service: Service) {
    state.user?.services.find((el: Service) => el.service === service.service) == service
  }
}

const actions: ActionTree<UserState, RootState> = {
  async sendStat(): Promise<any> {
    try {
      await sendStat()
      return Promise.resolve()
    } catch (error) {
      return Promise.reject(parseAxiosError(error as any))
    }
  },
  async loadUser({ commit }: UserContext): Promise<any> {
    try {
      const user = await getUserInfo()
      commit(SET_USER, user)
      return Promise.resolve()
    } catch (error) {
      return Promise.reject(parseAxiosError(error as any))
    }
  },
  async clear({ commit }: UserContext): Promise<void> {
    try {      
      commit(CLEAR_USER)
      localStorage.removeItem('accessToken')
      localStorage.removeItem('refreshToken')
      await logout()
      window.location.href = 'https://www.vdmar.ru/'
      return Promise.resolve()
    } catch (error) {
      return Promise.reject(parseAxiosError(error as any))
    }
  },
  async setUserService({ commit }: UserContext, service): Promise<any> {
    try {
      const params: SettingsSavePost = {
          service_uuid: service.service,
          album_types: service.album_types,
          genres: service.genres
      }
      const setUserService = await settingsSave(params)
      commit(SET_USER_SERVICES, service)
      return Promise.resolve()
    } catch (error) {
      return Promise.reject(error)
    }
  }
}

export const user = {
  namespaced: true,
  state: initialState,
  getters,
  mutations,
  actions
}
